import { Campaign, STO_FLAG } from 'modules/workflows';
import { TimeIn24HourClock } from 'ui/datePicker';
import { isEmpty } from 'lodash';

/**
 * Formats time received from backend to a preseve only hours and
 * minutes in a 24-hour format by excluding trailing zeroes
 *
 * Example: "05:30:00.000" => "05:30"
 */
export const formatTime = (time: string) => time.slice(0, 5) as TimeIn24HourClock;

export const isSTOEnabled = (dso: string[] = []) => dso.includes(STO_FLAG);
export const isCampaignSTOEnabled = (campaign: Partial<Campaign>) =>
  isSTOEnabled(campaign?.dataScienceOptimizations);
export const isCampaignAlertsEnabled = (campaign: Partial<Campaign>) =>
  !!campaign?.campaignAlertsEnabled;
export const isCampaignQuietHoursEnabled = (campaign: Partial<Campaign>) =>
  !isEmpty(campaign?.customQuietHours);

export const createSTOCampaignProps = (
  timeZone: string,
  windowHours?: number | string,
): Partial<Campaign> => ({
  dataScienceOptimizations: [STO_FLAG],
  schedulerMsgParams: {
    defaultTimeZone: timeZone,
    scheduleType: STO_FLAG,
    schedulerMsgIds: [], // hardcoded to this value in Angular version
    startTimeZone: timeZone,
    ...(windowHours && { windowHours: Number(windowHours) }),
  },
});
